module.exports = __webpack_public_path__ + "sprite.b5170348bbaea7cef73b.png";


//////////////////
// WEBPACK FOOTER
// /rightcompound/angular/node_modules/jquery.uniform/dist/images/default/sprite.png
// module id = ../../../../jquery.uniform/dist/images/default/sprite.png
// module chunks = styles